import { Typography } from "@mui/material";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { TitleContainer, Wrapper } from "../../style";
import AdminPricingTable from "./pricing/PricingCredits";
import PricingServices from "./pricing/pricingServices";
import "./SettingsStyle.less";
import { FormattedMessage } from "react-intl";

export const SettingsPage = () => {
  return (
    <Wrapper>
      <ColumnContainer doubleGap start style={{ height: "100vh" }}>
        <ColumnContainer>
          <TitleContainer>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="settings.title" />
            </Typography>
          </TitleContainer>
        </ColumnContainer>
        <ColumnContainer doubleGap>
          <AdminPricingTable />
          <PricingServices />
        </ColumnContainer>
      </ColumnContainer>
    </Wrapper>
  );
};
